import {isPropertyTypeAll} from './property-types';

export function pushEdapEvent(event, eventOptions, edapOptions) {
    window.edap.push((edap) => edap.trigger(event, eventOptions, edapOptions));
}

export function getRefinements(propertyType, destinationType) {
    let eventrefinements = [];
    if (!isPropertyTypeAll(propertyType)) {
        eventrefinements.push(propertyType);
    }
    if (destinationType) {
        eventrefinements.push(destinationType);
    }

    return eventrefinements.join(',');
}